// The session is gone (expired, or Redis flushed): tell the founder, forget the
// cached user and end the session server-side. Used by App.checkLoginStatus at
// boot and by the axios handler in index.jsx when a call fails mid-visit.
export default function logOutExpiredSession() {
  alert(
    'Your session expired or we could not verify your login. Please log in again.\n'
    + 'If you are unable to log in, please contact support: contact@angelspartners.com',
  );
  sessionStorage.clear();
  localStorage.clear();
  window.location.href = `${process.env.REACT_APP_DOMAIN_URL}/logout`;
}
